import styled from 'styled-components'

const ListWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`

export default ListWrapper
